import { useOfficial } from "@/lib/officialFlags";
import { CheckCircle2, Circle } from "lucide-react";
import { toast } from "sonner";

// Compact per-rodeo Official/Unofficial pill for map/list/calendar rows.
export function OfficialBox({ rodeoId, dark = false, className = "" }) {
  const { official, toggle } = useOfficial(rodeoId);
  const onClick = (e) => {
    e.stopPropagation();
    toggle();
    toast.success(!official ? "Official — counts toward standings" : "Unofficial — won't count toward standings");
  };
  return (
    <button onClick={onClick} data-testid={`official-box-${rodeoId}`}
      title="Toggle whether this rodeo counts toward your standings (My Rodeo Counts)"
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-[11px] font-semibold border transition-colors ${
        official
          ? "bg-[#3B6B1E] text-white border-[#3B6B1E]"
          : dark ? "bg-white/5 text-slate-300 border-white/15" : "bg-white text-slate-500 border-[#D7DBE0]"
      } ${className}`}>
      {official ? <CheckCircle2 className="w-3 h-3" /> : <Circle className="w-3 h-3" />}
      {official ? "Official" : "Unofficial"}
    </button>
  );
}

// Full-width toggle used inside the Info modal.
export function OfficialToggle({ rodeoId }) {
  const { official, toggle } = useOfficial(rodeoId);
  const onClick = () => {
    toggle();
    toast.success(!official ? "Marked Official — counts toward standings" : "Marked Unofficial — won't count toward standings");
  };
  return (
    <button onClick={onClick} data-testid={`info-official-${rodeoId}`}
      className={`flex items-center gap-2 w-full text-left px-3 py-2.5 rounded-lg border ${official ? "border-[#3B6B1E]/40 bg-[#3B6B1E]/8" : "border-[#D7DBE0] bg-[#F7F8FA]"}`}>
      {official ? <CheckCircle2 className="w-4 h-4 text-[#3B6B1E] shrink-0" /> : <Circle className="w-4 h-4 text-slate-400 shrink-0" />}
      <span className="flex-1">
        <span className={`block text-sm font-semibold ${official ? "text-[#3B6B1E]" : "text-slate-500"}`}>{official ? "Official rodeo" : "Unofficial rodeo"}</span>
        <span className="block text-[11px] text-slate-500">{official ? "Counts toward your standings" : "Won't count toward standings"} · applies to all your events here · PRCA caps counting at 85/event</span>
      </span>
    </button>
  );
}
